module.exports = __webpack_public_path__ + "static/media/p5_img3.830fb62c.png";